/* eslint-disable prefer-destructuring */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useContext, useEffect, useState } from 'react'

import { get, post } from '../utils/api'
import { getEnvs } from '../utils/env'

interface AuthContextProps {
  login: (username: string, password: string) => void
  logout: () => void
  isAuthenticated: boolean
  retrieveLoggedUser: () => void
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false)

  useEffect(() => {
    const { bypassLogin } = getEnvs()

    if (bypassLogin) {
      setIsAuthenticated(true)
    } else {
      retrieveLoggedUser().then((user: User | null) => {
        setIsAuthenticated(user != null)
      })
    }
  }, [])

  const login = async (username: string, password: string) => {
    try {
      await post(
        '/login/',
        { username, password },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
    } catch (error) {
      console.error(error)
      throw new Error('Login failed:')
    }

    setIsAuthenticated(true)
  }

  const logout = async () => {
    try {
      await post('/logout/', {}, {})
    } catch (error) {
      console.error(error)
      throw new Error('Logout failed')
    }

    setIsAuthenticated(false)
  }

  return (
    <AuthContext.Provider
      value={{ login, logout, isAuthenticated, retrieveLoggedUser }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export interface User {
  id: number
  username: string
  email: string
  firstName?: string
  lastName?: string
}

export const retrieveLoggedUser = async () => {
  try {
    const user = await get<User>('/current-user/', {})

    if (user) {
      console.info('logged user', user)
      return user
    }
  } catch (error) {
    console.error('logged user error', error)
    throw new Error('Unable to retrieve logged user')
  }

  return null
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
